import type { Router } from 'expo-router';

type SpeciesSearchRouter = Pick<Router, 'canGoBack' | 'back' | 'replace'>;

type NavigateBackToFormParams = {
  router: SpeciesSearchRouter;
  segments: string[];
  reportId?: string;
};

export const navigateBackToSpeciesForm = ({
  router,
  segments,
  reportId,
}: NavigateBackToFormParams): void => {
  const isEditRoute = Boolean(
    reportId && segments.includes('reports') && segments.includes('edit'),
  );
  const isBoardRoute = segments.includes('board');
  const editBasePath = isBoardRoute
    ? '/(tabs)/board/reports/[reportId]/edit'
    : '/(tabs)/reports/[reportId]/edit';
  const creationBasePath = '/(tabs)/report-creation';
  const navigateToFallback = (): void => {
    if (isEditRoute && reportId) {
      router.replace({
        pathname: editBasePath,
        params: { reportId },
      });
      return;
    }

    router.replace(creationBasePath);
  };

  if (!router.canGoBack()) {
    navigateToFallback();
    return;
  }

  router.back();

  setTimeout(() => {
    if (router.canGoBack()) {
      router.back();
      return;
    }

    navigateToFallback();
  }, 0);
};

export const navigateBackToSpeciesSearch = (
  router: Pick<SpeciesSearchRouter, 'back'>,
): void => {
  router.back();
};
